type FooterMenuItem = {
  name: string
  link: string
  blank: boolean
}

export const getFooterMenu = (language: string): FooterMenuItem[] => [
  {
    name: 'KARTE利用規約',
    link: language === 'en' ? '/legal/terms-of-use-en.html' : '/legal/terms-of-use.html',
    blank: false,
  },
  {
    name: 'KARTE SLA',
    link: '/karte-sla.html',
    blank: false,
  },
  {
    name: 'オプトアウト設定方法',
    link: '/optout/',
    blank: false,
  },
  {
    name: '情報セキュリティ基本方針',
    link: '/security-policy.html',
    blank: false,
  },
  {
    name: 'プライバシーポリシー',
    link: language === 'en' ? '/karte-policy-en.html' : '/karte-policy.html',
    blank: false,
  },
  {
    name: 'セキュリティホワイトペーパー',
    link: '/assets/pdf/karte-whitepaper.pdf',
    blank: true,
  },
  {
    name: 'KARTEの利用に伴うプライバシーポリシーの作成方針',
    link: '/karte-use-policy.html',
    blank: false,
  },
  {
    name: '個人情報保護方針',
    link: 'https://plaid.co.jp/privacy-policy.html',
    blank: true,
  },
  {
    name: '運営会社',
    link: 'https://plaid.co.jp/',
    blank: true,
  },
]
